import React, { FC } from 'react';
import styles from '../Input.module.css';

export interface RulesListProps {
    title?: string;
    rules: { label: string; verify: boolean }[];
}

export const RulesList: FC<RulesListProps> = ({ title, rules }) => {
    return (
        <div className={styles['instructions-list']}>
            {title && <p>{title}</p>}
            <ul>
                {rules.map((rule, index) => (
                    <li key={index} className={rule['verify'] ? styles.done : styles.todo}>
                        {rule['label']}
                    </li>
                ))}
            </ul>
        </div>
    );
};
